import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { RatesTable } from '@mews-commander/modules/src/modules/enterpriseRateManagement';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const guideLink = createGuideLink(ArticlePath.RateManagementPortfolio);

    return <RatesTable guideLink={guideLink} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/EnterpriseRateManagement/Rate/Index/')({
    component: Component,
    staticData: {
        title: TextKey.RatePlural,
        owner: MewsTeam.Pricing,
        type: RouteType.Frontend,
    },
});
